/**
 * Video Blog - Handles video popup functionality using GLightbox
 */

document.addEventListener("DOMContentLoaded", function () {
  // Check if we're on a video blog page
  const videoBlogs = document.querySelectorAll(".c-blog--videos");

  if (videoBlogs.length === 0) {
    return; // Exit if no video blog sections found
  }

  // Wait for GLightbox to be available
  if (typeof GLightbox !== "undefined") {
    initializeVideoLightbox();
  } else {
    // Fallback: wait a bit and try again
    setTimeout(() => {
      if (typeof GLightbox !== "undefined") {
        initializeVideoLightbox();
      } else {
        console.warn("GLightbox not available - video popups will not work");
      }
    }, 100);
  }
});

function initializeVideoLightbox() {
  const lightbox = GLightbox({
    selector: ".glightbox",
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
    plyr: {
      config: {
        ratio: "16:9",
        youtube: {
          noCookie: true,
          rel: 0,
          showinfo: 0,
          iv_load_policy: 3,
        },
        vimeo: {
          byline: false,
          portrait: false,
          title: false,
        },
      },
    },
  });
}
